import './App.css';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { store } from './redux/store'
import { Provider } from 'react-redux'
import draculaTheme from './constants/theme';
import { BrowserRouter } from 'react-router-dom'
import AppRoutes from './routes/AppRoutes'

export default () => {
  return (
    <Provider store={store}>
      <ThemeProvider theme={draculaTheme}>
        <CssBaseline />
        <BrowserRouter>
          <AppRoutes/>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
}
